module.exports = __webpack_public_path__ + "img/img_apps_desk.3e1de21.png";